import api from "../../utils/api";

const API_URL = "/news";

export async function listNews() {
    try {
        const { data } = await api.get("/news");
        return data;
    } catch (e) {
        if (e?.response?.status === 403) {
            console.log("News access denied (403)");
        } else {
            console.warn("listNews fetch failed:", e);
        }
        return [];
    }
}

export const createNews = async (data) => {
    const res = await api.post(API_URL, data);
    return res.data;
};

export const updateNews = async (id, data) => {
    const res = await api.patch(`${API_URL}/${id}`, data);
    return res.data;
};

export const deleteNews = async (id) => {
    const res = await api.delete(`${API_URL}/${id}`);
    return res.data;
};

export const toggleReaction = async (id, emoji) => {
    const res = await api.post(`${API_URL}/${id}/react`, { emoji });
    return res.data;
};

export const listReactions = async () => {
    const res = await api.get(`${API_URL}/reactions`);
    return res.data;
};

export const listComments = async (newsId) => {
    const res = await api.get(`${API_URL}/${newsId}/comments`);
    return res.data;
};

export const addComment = async (newsId, comment) => {
    const res = await api.post(`${API_URL}/${newsId}/comments`, { comment });
    return res.data;
};

export const deleteComment = async (commentId) => {
    const res = await api.delete(`${API_URL}/comments/${commentId}`);
    return res.data;
};
